<div mat-dialog-content>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top p-50">
        <div style="text-align: center;padding: 30px;">
            <p class="simpli-color3">
                {{ msg }}
            </p>
        </div>
        <div style="text-align: center;">
            <button style="width: 200px;" mat-flat-button mat-dialog-close type="button" routerLink="/login" >Ingresar a mi cuenta</button>
        </div>
    </div>
</div>